import type FinancialInstitutionPatternModel from './financial-institution-pattern';
import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';
import type UserModel from './user.ts';
import type PublicAssetModel from './public-asset.ts';
import type AccountModel from './account.ts';
import type PostalAddressModel from './postal-address.ts';
import type AttachmentModel from './attachment.ts';
import type AccountTransactionModel from './account-transaction.ts';
import type CreditorModel from './creditor.ts';
import { Type } from '@warp-drive/core-types/symbols';

// TODO: don't use enums in this app!
export enum ServicerAddressType {
  SINGLE_ADDRESS = 'SINGLE_ADDRESS',
  ACCOUNT_NUMBER = 'ACCOUNT_NUMBER',
  LOAN_TYPE = 'LOAN_TYPE',
  MANUAL = 'MANUAL',
}

export default class FinancialInstitutionModel extends Model {
  @attr declare name: string;
  @attr declare publicOrdinalValue: number;
  @attr declare isActive: boolean;
  @attr declare isPublic: boolean;
  @attr declare manifestInstitutionId: string;
  @attr declare legacyId: string;
  @attr declare surrogateUserId: string;
  @attr declare fundSource: string;
  @attr declare canLinkOn: string;
  @attr declare statusMessage: string;
  @attr declare hasObservabilityInstructions: boolean;
  @attr declare servicerAddressType: ServicerAddressType;
  @attr declare accountNumberPattern?: string;
  @attr declare activeConnectedAccountsCount: number;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('user', { async: false, inverse: null })
  declare user: UserModel;
  @belongsTo('public-asset', { async: false, inverse: null })
  declare logo: PublicAssetModel;
  // This is the wrong inverse, should be 'financialInstitution' but fixing
  // breaks linking so will return to it later.
  @hasMany('account', { async: false, inverse: null })
  declare accounts: AccountModel[];
  @hasMany('account-transaction', { async: false, inverse: null })
  declare accountTransactions: AccountTransactionModel[];
  @hasMany('postal-address', {
    async: false,
    inverse: 'postalAddressable',
    as: 'postal-addressable',
  })
  declare postalAddresses: PostalAddressModel[];
  @hasMany('attachment', { async: false, inverse: null })
  declare attachments: AttachmentModel[];
  @hasMany('financial-institution-pattern', { async: false, inverse: null })
  declare financialInsitutionPatterns: FinancialInstitutionPatternModel[];
  @hasMany('creditor', { async: false, inverse: null })
  declare creditors: CreditorModel[];

  [Type] = 'financial-institution' as const;
}
